import { IComponentOptions } from 'angular';
import { GradPlanningWizardTableCtrl } from './grad-planning-wizard-table.controller';

export const GradPlanningWizardTableComponent: IComponentOptions = {
  bindings: {
    //
  },
  controller: GradPlanningWizardTableCtrl,
  template: require('./grad-planning-wizard-table.html'),
};
